import { render, staticRenderFns } from "./ClockTime.vue?vue&type=template&id=8806cd7c&"
import script from "./ClockTime.vue?vue&type=script&lang=js&"
export * from "./ClockTime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports